<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">خصوصیات جسمانی و روانی شاغل</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-9">
          <label class="form-label fw-bold">خصوصیات</label>
          <input
              type="text"
              class="form-control"
              placeholder="یک خصوصیت وارد کنید"
              v-model="newPhysicalTrait.name"
          />
        </div>
        <div class="col-md-3">
          <GeneralButton @clicked="addPhysicalTrait"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- PhysicalTraits Table -->
      <GeneralTable
          :headers="['خصوصیت']"
          :fields="['name']"
          :items="jobQualification.physical_traits"
          :openEditModalMethod="openEditModal"
          @remove="removePhysicalTrait"
      />

      <!-- Edit PhysicalTrait Modal -->
      <GeneralModal
          v-show="editedPhysicalTrait"
          :title="'ویرایش خصوصیت جسمانی یا روانی'"
          modal-id="physicalModalId"
          @save="updatePhysicalTrait"
      >
        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-label fw-bold">خصوصیت</label>
            <input
                type="text"
                class="form-control"
                placeholder="خصوصیت را وارد کنید"
                v-if="editedPhysicalTrait"
                v-model="editedPhysicalTrait.name"
            />
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import { Modal } from 'bootstrap';
import { useToast } from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  name: ""
}
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal },
  data() {
    return {
      newPhysicalTrait: structuredClone(baseStructure),
      editedPhysicalTrait: null,
      editIndex: null,
    };
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    }
  },
  methods: {
    async addPhysicalTrait() {
      if (!this.newPhysicalTrait.name) {
        toast.error('خصوصیت را وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newPhysicalTrait,
        endpoint: '/job-qualifications/store-physical-trait',
      });

      this.jobQualification.physical_traits = [...this.jobQualification.physical_traits, structuredClone(response.data)];
      this.newPhysicalTrait = structuredClone(baseStructure);
    },
    removePhysicalTrait(index) {
      const physicalTrait = this.jobQualification.physical_traits.find((_, i) => i === index);
      this.jobQualification.physical_traits = this.jobQualification.physical_traits.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: physicalTrait.id,
        endpoint: '/job-qualifications/delete-physical-trait',
      });
    },
    openEditModal(physicalTrait, index) {
      this.editedPhysicalTrait = structuredClone(physicalTrait);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('physicalModalId'));
      modal.show();
    },
    updatePhysicalTrait() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedPhysicalTrait.name) {
        toast.error('خصوصیت را وارد کنید!');
        return;
      }

      this.jobQualification.physical_traits.splice(this.editIndex, 1, { ...this.editedPhysicalTrait });

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedPhysicalTrait,
        endpoint: '/job-qualifications/update-physical-trait',
      });

      this.editIndex = null;
      this.editedPhysicalTrait = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('physicalModalId'));
      modal.hide();
    }
  },
};
</script>
